const getCompanySizeSortValue = (value) => {
    const raw = String(value || '').trim().toLowerCase();
    if (!raw || raw === 'n/a' || raw === 'na' || raw === '-') return null;
    if (raw.includes('several 1000')) return 3000;
    if (raw.includes('under 30')) return 30;
    if (raw.includes('over 100000')) return 100001;

    const rangeMatch = raw.match(/(\d[\d,.\s]*)\s*[-–—]\s*(\d[\d,.\s]*)/);
    if (rangeMatch) {
        const min = Number(rangeMatch[1].replace(/[^\d]/g, ''));
        const max = Number(rangeMatch[2].replace(/[^\d]/g, ''));
        if (Number.isFinite(min) && Number.isFinite(max)) return (min + max) / 2;
    }

    const numericValue = Number(raw.replace(/[^\d]/g, ''));
    return Number.isFinite(numericValue) ? numericValue : null;
};

export const mobileCompanySortDefinitions = {
    name: { defaultDirection: 'asc', type: 'text', value: (company) => String(company.title || '').trim() },
    country: { defaultDirection: 'asc', type: 'text', value: (company) => String(company.country || '').trim() },
    city: { defaultDirection: 'asc', type: 'text', value: (company) => String(company.cityRegion || '').trim() },
    openJobs: { defaultDirection: 'desc', type: 'number', value: (company) => company.openJobsTotal },
    internships: { defaultDirection: 'desc', type: 'number', value: (company) => company.openJobsIntern },
    companySize: { defaultDirection: 'desc', type: 'number', value: (company) => getCompanySizeSortValue(company.globalSize || company.localSize) },
    rating: { defaultDirection: 'desc', type: 'number', value: (company) => {
        const rating = Number(company.googleRating);
        return Number.isFinite(rating) && rating > 0 ? rating : null;
    } },
    lastUpdate: { defaultDirection: 'desc', type: 'number', value: (company) => {
        const rawDate = company.latestDataUpdate || company.updatedAt;
        if (!rawDate) return null;
        const timestamp = new Date(rawDate).getTime();
        return Number.isFinite(timestamp) ? timestamp : null;
    } },
};

export const getMobileSortedCompanies = (sourceCompanies, field, direction) => {
    const definition = mobileCompanySortDefinitions[field];
    if (!definition) return sourceCompanies;
    const multiplier = direction === 'asc' ? 1 : -1;

    return [...sourceCompanies].sort((a, b) => {
        const rawA = definition.value(a);
        const rawB = definition.value(b);
        const aMissing = rawA === null || rawA === undefined || rawA === '' ||
            (definition.type === 'number' && !Number.isFinite(Number(rawA)));
        const bMissing = rawB === null || rawB === undefined || rawB === '' ||
            (definition.type === 'number' && !Number.isFinite(Number(rawB)));

        if (aMissing !== bMissing) return aMissing ? 1 : -1;
        if (aMissing && bMissing) return 0;

        const comparison = definition.type === 'text'
            ? String(rawA).toLowerCase().localeCompare(String(rawB).toLowerCase())
            : Number(rawA) - Number(rawB);
        return comparison * multiplier;
    });
};

export const mobileCompanySortOptions = [
    { field: 'name', label: 'Company' },
    { field: 'country', label: 'Country' },
    { field: 'city', label: 'City' },
    { field: 'openJobs', label: 'Open jobs' },
    { field: 'internships', label: 'Internships' },
    { field: 'companySize', label: 'Company size' },
    { field: 'rating', label: 'Rating' },
    { field: 'lastUpdate', label: 'Last update' },
];
